"use client";

import { BarChart3, HandCoins, HeartHandshake, Sparkles, TrendingUp } from "lucide-react";

const TABS = [
  { id: "overview", label: "Overview", icon: BarChart3 },
  { id: "income", label: "Income", icon: HandCoins },
  { id: "roi", label: "ROI", icon: TrendingUp },
  { id: "ai-analysis", label: "AI Analysis", icon: Sparkles },
  { id: "beneficiaries", label: "Beneficiaries", icon: HeartHandshake },
];

export default function TabNavigation({ activeTab, onTabChange }) {
  const canUseAIAnalysis = ["finance", "admin", "management"].includes((localStorage.getItem("user_role") || "").toLowerCase());
  const visibleTabs = TABS.filter((tab) => tab.id !== "ai-analysis" || canUseAIAnalysis);
  return (
    <div className="flex gap-1.5 flex-wrap mb-6 p-2 bg-white rounded-xl border border-gray-200 shadow-sm print:hidden">
      {visibleTabs.map((tab) => (
        <button
          key={tab.id}
          onClick={() => onTabChange(tab.id)}
          className={`flex items-center gap-2 px-4 py-3 rounded-lg font-medium text-sm transition-all duration-200 ${
            activeTab === tab.id
              ? "bg-gradient-to-r from-[#D67C2C] to-orange-600 text-white shadow-md"
              : "text-gray-600 hover:bg-gray-50 hover:text-gray-900"
          }`}
        >
          <tab.icon className="w-4 h-4" />
          {tab.label}
        </button>
      ))}
    </div>
  );
}
